import swedish from './sv-se';
import english from './en';

const language = (preferedLanguage) => {
    switch (preferedLanguage) {
    case 'sv-se': {
        return swedish;
    }
    case 'en': {
        return english;
    }
    default:
        return swedish;
    }
};

export default language;
